<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/CZXUoF/tc-custom/9780253012593.jpg?1732051520072" alt="This image is the cover for the book Rachmaninoff's Complete Songs, Russian Music Studies"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Rachmaninoff's Complete Songs, Russian Music Studies
      </h1>
      <p class="bookDescription body article font2">
        <p>Sergei Rachmaninoff—the last great Russian romantic and arguably the finest pianist of the late 19th and early 20th centuries—wrote 83 songs, which are performed and beloved throughout the world. Like German Lieder and French mélodies, the songs were composed for one singer, accompanied by a piano. In this complete collection, Richard D. Sylvester provides English translations of the songs, along with accurate transliterations of the original texts and detailed commentary. Since Rachmaninoff viewed these "romances" primarily as performances and painstakingly annotated the scores, this volume will be especially valuable for students, scholars, and practitioners of voice and piano.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Richard D. Sylvester
      </h2>
      
      <p class="authorDescription body article"><P>Richard D. Sylvester is Professor Emeritus of Russian at Colgate University and author of Tchaikovsky's Complete Songs: A Companion with Texts and Translations (IUP, 2004). </P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Indiana University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6442dbcd